import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ModalLayerComponent } from "../modal-layer/modal-layer.component";
import { LayerService } from "../../../home/services/layers/layer.service";
import { ModalCategoryComponent } from "../modal-category/modal-category.component";
import { CategoryService } from "../../../home/services/category_layers/category.service";
import { FormService } from "../../../home/services/forms/form.service";
import { AdmonActiveComponent } from "../modal_admon_active/admon-active/admon-active.component";
import { ModalFormsComponent } from "../modal-forms/modal-forms.component";
import { MapService } from "../../../view/services/map.service";
import { LoginService } from "../../services/login/login.service";
import { AnyTypeAnnotation } from "@babel/types";


@Component({
  selector: "app-modal-workspace",
  templateUrl: "./modal-workspace.component.html",
  styleUrls: ["./modal-workspace.component.css"]
})
export class ModalWorkspaceComponent implements OnInit {
  layersAdd: any[] = [];
  categoriesAdd: any[] = [];
  formsAdd: any[] = [];
  userId : any;
  userRol : any;
  formsAsignados = false;

  constructor(
    public mapService: MapService,
    public layerService: LayerService,
    public loginService: LoginService,
    public categoryService: CategoryService,
    public formService: FormService,
    protected dialog: MatDialog
  ) {

    this.userId = this.loginService.getuserId();
this.userRol = this.loginService.getUserRol();
if(this.userRol == "Administrador"){
    this.categoryService.getCategories().subscribe((data: {}) => {
      for (const key in data) {
  if (Object.prototype.hasOwnProperty.call(data, key)) {
    const element = data[key];
this.categoriesAdd.push(element);
  }}
    });

    this.layerService.getLayers().subscribe((data: {}) => {
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.layersAdd.push(element);
        }}
     
    }); 

     this.formService.getForms().subscribe((data: {}) => {
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.formsAdd.push(element);
        }}
    });
}else{
      this.formService.getFormsUser(this.userId).subscribe((dataForms: {}) => {
        if(!(dataForms[0])){this.formsAsignados = true;};
for (const key in dataForms) {
  if (Object.prototype.hasOwnProperty.call(dataForms, key)) {
    const element = dataForms[key];
    this.formService.getForm(element.formulario_id).subscribe((dataForm: {}) => {
      this.formsAdd.push(dataForm);
      this.layerService.getLayer(dataForm["capa_id"]).subscribe((dataLayer: {}) => {
        if (!(this.layersAdd.find(element => element["capa_id"] == dataLayer["capa_id"]))) {
          this.layersAdd.push(dataLayer);
        }
this.categoryService.getCategory(dataLayer["categoria_capa_id"]).subscribe((dataCategory: {}) => {
  if (!(this.categoriesAdd.find(element => element["categoria_capa_id"] == dataLayer["categoria_capa_id"]))) {
         this.categoriesAdd.push(dataCategory);
        }

});
      });
    });
  }
}
 });
}


 
    
  }

  ngOnInit() {}

  createLayer() {
    this.dialog
      .open(ModalLayerComponent, { data: {} })
      .afterClosed()
      .subscribe(response => {
        this.layerService.getLayers().subscribe((data: {}) => {
         for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.layersAdd.push(element);
        }}
        });
      });
  }

  editLayer(id) {
    this.layerService.getLayer(id).subscribe((data: {}) => {
      this.dialog
        .open(ModalLayerComponent, { data: { data } })
        .afterClosed()
        .subscribe(response => {
          this.layerService.getLayers().subscribe((data: {}) => {
          for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.layersAdd.push(element);
        }}
          });
          alert("Se editó correctamente la capa");
        });
    });
  }

  deleteLayer(id) {
    this.layerService.deleteLayer(id).subscribe((data: {}) => {
      this.layerService.getLayers().subscribe((data: {}) => {
       for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.layersAdd.push(element);
        }}
      });
      alert("Se eliminó correctamente la capa");
    });
  }

  createCategory() {
    this.dialog
      .open(ModalCategoryComponent, { data: {} })
      .afterClosed()
      .subscribe(response => {
        this.categoryService.getCategories().subscribe((data: {}) => {
         for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.categoriesAdd.push(element);
        }}
        });
      });
  }

  editCategory(id) {
    this.categoryService.getCategory(id).subscribe((data: {}) => {
      this.dialog
        .open(ModalCategoryComponent, { data: { data } })
        .afterClosed()
        .subscribe(response => {
          this.categoryService.getCategories().subscribe((data: {}) => {
          for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.categoriesAdd.push(element);
        }}
            alert("Se editó/eliminó correctamente la categoría");
          });
        });
    });
  }

  createForm() {
    this.dialog
      .open(ModalFormsComponent, { data: {} })
      .afterClosed()
      .subscribe(response => {
        this.formService.getForms().subscribe((data: {}) => {
         for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.formsAdd.push(element);
        }}
        });
      });
  }

  editForm(id) {
    this.dialog
      .open(AdmonActiveComponent, { data: { id } })
      .afterClosed()
      .subscribe(response => {
        this.categoryService.getCategories().subscribe((data: {}) => {
        for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.categoriesAdd.push(element);
        }}
        });
      });
  }

  deleteForm(id) {
    this.formService.deleteForm(id).subscribe((data: {}) => {
      this.formService.getForms().subscribe((data: {}) => {
        for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
      this.formsAdd.push(element);
        }}
      });
      alert("Se eliminó correctamente el formulario");
    });
  }

  changeActuallyCategoryLayer(category, layer, form, formId) {
    this.mapService.setCurrentCategory(category);
    this.mapService.setCurrentLayer(layer);
    this.mapService.setCurrentForm(form);
    this.mapService.setCurrentFormId(formId);
    this.mapService.addActives();
    this.dialog.closeAll();
  }
}
